'use client';

import { useProductDetails } from '@app/pdp/hooks';
import { mapAddToCartItems } from '@app/pdp/utils';
import {
    getSearchStats,
    trackAddToCart,
    trackAddToCartMethod,
    trackEEAddToCart,
    TrackingParams,
    velocityTrackAddToCart,
} from '@libs/analytics';
import { NavigationListTypes, useCart, usePageLayout } from '@libs/common-next';
import { AddToCartType } from '@libs/ocapi';
import type { Currency, DeliveryType } from '@libs/core';
import type { AddItemRequestBody } from '@libs/common-node';

export const useAddToCartAnalytics = () => {
    const { product, selectedProduct } = useProductDetails();
    const { selectedStore } = usePageLayout();
    const { itemsList } = useCart();

    const addToCartAnalytics = (
        body: AddItemRequestBody,
        currency: Currency
    ) => {
        const deliveryType = body.fulfillmentMethod as DeliveryType;
        const autoshipFrequency = body.autoshipFrequency
            ? Number(body.autoshipFrequency)
            : undefined;
        const quantity = body.quantity;

        trackEEAddToCart(
            [
                {
                    algoliaHit: product,
                    parameters: {
                        quantity,
                        fulfillmentMethod: deliveryType,
                        type: TrackingParams.STANDARD_PDP,
                        autoshipFrequency,
                        storeID: body.storeId,
                    },
                },
            ],
            AddToCartType.STANDARD
        );
        trackAddToCart();
        trackAddToCartMethod(deliveryType);

        if (selectedStore.store) {
            const { searchTerm } = getSearchStats();

            velocityTrackAddToCart(
                selectedProduct,
                currency,
                NavigationListTypes.STANDARD_PDP,
                'no',
                [
                    mapAddToCartItems({
                        product,
                        selectedProduct,
                        quantity,
                        store: selectedStore.store,
                        cartCount: itemsList.length + quantity,
                        selectedDeliveryMethod: deliveryType,
                        lastSearchQuery: searchTerm,
                        frequency: autoshipFrequency,
                    }),
                ]
            );
        }
    };

    return addToCartAnalytics;
};
